import React from 'react';
import { ArrowLeft, Users, Target, BookOpen, Globe, Award } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import logoImage from '../images/image.png';

const About: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-gradient-to-r from-green-600 to-green-700 text-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center space-x-2 text-sm text-green-100 mb-6">
            <button 
              onClick={() => navigate('/publications')} 
              className="flex items-center space-x-1 text-green-100 hover:text-white transition-colors"
            >
              <ArrowLeft className="h-4 w-4" />
              <span>Dashboard</span>
            </button>
          </div>
          
          <div className="text-center">
            <img 
              src={logoImage} 
              alt="Publication Tracker Logo" 
              className="h-20 w-auto mx-auto mb-6"
            />
            <p className="text-xl text-green-100 max-w-3xl mx-auto">
              <a href="mailto:griffith.gao@ucsf.edu" className="text-green-100 hover:text-white">Send email to Griffith Gao (griffith.gao@ucsf.edu) for any questions</a>
            </p>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Features Section */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
          <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
            <BookOpen className="h-8 w-8 text-green-600 mb-4" />
            <h3 className="text-xl font-semibold text-gray-900 mb-3">Publication Pipeline</h3>
            <p className="text-gray-600">
              Track your research through four distinct stages: Ideation, Review & Team, 
              Data Analysis, and Manuscript drafting.
            </p>
          </div>

          <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
            <Users className="h-8 w-8 text-green-600 mb-4" />
            <h3 className="text-xl font-semibold text-gray-900 mb-3">Collaborative Research</h3>
            <p className="text-gray-600">
              Enable seamless co-author recruitment and team collaboration with 
              built-in communication tools and role management.
            </p>
          </div>

          <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
            <Award className="h-8 w-8 text-green-600 mb-4" />
            <h3 className="text-xl font-semibold text-gray-900 mb-3">Committee Oversight</h3>
            <p className="text-gray-600">
              Publication Committee review and approval before submission.
            </p>
          </div>
        </div>

        {/* How It Works Section */}
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-8 mb-8">
          <h2 className="text-3xl font-bold text-gray-900 text-center mb-8">How It Works</h2>
          
          <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
            <div className="text-center">
              <div className="w-16 h-16 bg-blue-600 text-white rounded-full flex items-center justify-center text-2xl font-bold mx-auto mb-4">1</div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Ideation</h3>
              <p className="text-gray-600 text-sm">
                Researchers submit analysis plans with abstracts, methods, and expected results
              </p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-yellow-600 text-white rounded-full flex items-center justify-center text-2xl font-bold mx-auto mb-4">2</div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Review & Team</h3>
              <p className="text-gray-600 text-sm">
                Committee approval and co-author recruitment for approved projects
              </p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-purple-600 text-white rounded-full flex items-center justify-center text-2xl font-bold mx-auto mb-4">3</div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Data Analysis</h3>
              <p className="text-gray-600 text-sm">
                Perform analysis with Data Team support and collaborative tools
              </p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-indigo-600 text-white rounded-full flex items-center justify-center text-2xl font-bold mx-auto mb-4">4</div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Manuscript</h3>
              <p className="text-gray-600 text-sm">
                Draft and refine manuscripts for journal submission
              </p>
            </div>
          </div>
        </div>

        {/* Contact Section */}
        {/* <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-8">
          <div className="text-center">
            <Globe className="h-12 w-12 text-green-600 mx-auto mb-4" />
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Get In Touch</h2>
            <p className="text-lg text-gray-600 mb-6">
              Have questions about the Publication Tracker system? We're here to help.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button className="bg-green-600 text-white px-6 py-3 rounded-lg hover:bg-green-700 transition-colors">
                Contact Support
              </button>
              <button className="border border-green-600 text-green-600 px-6 py-3 rounded-lg hover:bg-green-50 transition-colors">
                View Documentation
              </button>
            </div>
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default About;
